/* Generated by restful-react */

import React from 'react'
import { Get, GetProps, useGet, UseGetProps } from 'restful-react'

export const SPEC_VERSION = 'v1'
export interface IPhoneSettingsProps {
  phoneModel: string
  phoneOs: string
  cellPhone: string
  lastPingAt?: string
  settings: {
    pushToken?: string
    likelyStatus?: 'turned_off' | 'background' | 'foreground' | 'not_setup'
    turnedOffAt?: string
    lastBackgroundAt?: string
    lastForegroundAt?: string
    lastTrackingPausedAt?: string
    lastTrackingStartedAt?: string
    transfixAppVersion?: string
    locationPermission?: {
      label?: 'authorizedAlways' | 'authorizedWhenInUse' | 'denied' | 'restricted'
      info?:
        | 'Driver is all set'
        | 'Driver is tracking while the app is open. The app will continue tracking for a few minutes in background but not for long.'
        | "When the authorization status is denied, your app can't use location services."
        | 'The user cannot change this app’s status, possibly due to active restrictions such as parental controls being in place.'
      labelType?: 'success' | 'warning' | 'error' | 'error'
    }
    pushNotificationPermission?: {
      label?: 'authorized' | 'denied'
      info?:
        | 'Driver is all set'
        | 'Not Required: Push Notification helps us reviving the app if it stopped tracking'
      labelType?: 'success' | 'error'
    }
  }
}

export interface GetPhoneSettingsPathParams {
  id: number
}

export type GetPhoneSettingsProps = Omit<
  GetProps<IPhoneSettingsProps, unknown, void, GetPhoneSettingsPathParams>,
  'path'
> &
  GetPhoneSettingsPathParams

/**
 * Get Details Phone Settings
 */
export const GetPhoneSettings = ({ id, ...props }: GetPhoneSettingsProps) => (
  <Get<IPhoneSettingsProps, unknown, void, GetPhoneSettingsPathParams>
    path={`/v1/phone_settings/${id}`}
    {...props}
  />
)

export type UseGetPhoneSettingsProps = Omit<
  UseGetProps<IPhoneSettingsProps, unknown, void, GetPhoneSettingsPathParams>,
  'path'
> &
  GetPhoneSettingsPathParams

/**
 * Get Details Phone Settings
 */
export const useGetPhoneSettings = ({ id, ...props }: UseGetPhoneSettingsProps) =>
  useGet<IPhoneSettingsProps, unknown, void, GetPhoneSettingsPathParams>(
    (paramsInPath: GetPhoneSettingsPathParams) => `/v1/phone_settings/${paramsInPath.id}`,
    { pathParams: { id }, ...props }
  )
